export default {
      id: "icon-bothermorlion-usage",
      viewBox: "0 0 67 67",
      url: __webpack_public_path__ + "icons.svg#icon-bothermorlion",
      toString: function () {
        return this.url;
      }
    }